export default __webpack_public_path__ + "static/media/T&C.7e737619.pdf";